import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'reactstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as modalActionCreators from 'store/modal'
import { modalMap } from 'lib/modals'
import ErrorBoundary from 'components/ErrorBoundary'

export class ModalContainer extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    isOpen: PropTypes.bool,
    modalData: PropTypes.string,
    modalType: PropTypes.string,
  }

  render() {
    const { props } = this
    const modalOptions = modalMap[props.modalType]
    if (!modalOptions) return null
    const ModalContent = modalOptions.component
    return (
      <ErrorBoundary>
        {this.props.modalType && (
          <Modal
            backdrop="static"
            centered
            fade
            isOpen={props.isOpen}
            keyboard
            size={modalOptions.size}
            toggle={props.closeModal}
          >
            <ModalContent closeModal={props.closeModal} {...props.modalData} />
          </Modal>
        )}
      </ErrorBoundary>
    )
  }
}

function mapStateToProps({ modal }) {
  return {
    ...modal,
  }
}

export default connect(mapStateToProps, dispatch =>
  bindActionCreators({ ...modalActionCreators }, dispatch),
)(ModalContainer)
